import { createStore } from "redux";

const isBrowser = typeof window !== "undefined";

const defaultSidebarShow = isBrowser ? window.innerWidth >= 992 : true;
const savedSidebarShow = isBrowser
  ? JSON.parse(localStorage.getItem("sidebarShow") || "null")
  : null;

const initialState = {
  sidebarShow:
    isBrowser && window.innerWidth < 992
      ? false
      : savedSidebarShow !== null
        ? savedSidebarShow
        : defaultSidebarShow,
  sidebarUnfoldable: false,
};

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case "set": {
      const nextState = { ...state, ...rest };
      if (typeof window !== "undefined") {
        localStorage.setItem(
          "sidebarShow",
          JSON.stringify(nextState.sidebarShow),
        );
      }
      return nextState;
    }
    default:
      return state;
  }
};

const store = createStore(changeState);
export default store;
